import { $, $$ } from '../lib/dom.js';
import { reduceMotion } from '../lib/env.js';

/* Contador de estadísticas.
   Réplica de componentDidMount + animateStats del template:
   IntersectionObserver al 40 %, 1400 ms, easing easeOutCubic. */
export function initStats() {
  const wrap = $('[data-stats]');
  if (!wrap) return;

  const nums = $$('[data-stat-to]', wrap);
  if (!nums.length) return;

  function render(p) {
    nums.forEach((el) => {
      const to = parseFloat(el.getAttribute('data-stat-to')) || 0;
      const prefix = el.getAttribute('data-stat-prefix') || '';
      const suffix = el.getAttribute('data-stat-suffix') || '';
      el.textContent = prefix + Math.round(to * p) + suffix;
    });
  }

  // Sin animación: el HTML ya trae los valores finales.
  if (reduceMotion || !('IntersectionObserver' in window)) {
    render(1);
    return;
  }

  function animate() {
    const t0 = performance.now();
    const dur = 1400;
    (function tick(t) {
      const p = Math.min(1, (t - t0) / dur);
      render(1 - Math.pow(1 - p, 3));
      if (p < 1) requestAnimationFrame(tick);
    })(t0);
  }

  render(0);
  const io = new IntersectionObserver(
    (entries) => {
      if (entries.some((e) => e.isIntersecting)) {
        io.disconnect();
        animate();
      }
    },
    { threshold: 0.4 }
  );
  io.observe(wrap);
}
